import { jsx as r } from "react/jsx-runtime";
import { forwardRef as m } from "react";
const c = m(({
  stroke: o = "currentColor",
  strokeWidth: n = "2",
  strokeLinecap: a = "round",
  strokeLinejoin: e = "round",
  fill: s = "#000",
  size: t = "24",
  viewBox: l = "0 0 30 30",
  style: d = {
    transform: "scale(1.5)"
  },
  ...h
}, f) => /* @__PURE__ */ r(
  "svg",
  {
    ref: f,
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: l,
    fill: s,
    stroke: o,
    strokeWidth: n,
    strokeLinecap: a,
    strokeLinejoin: e,
    style: d,
    ...h,
    children: /* @__PURE__ */ r("g", { transform: "translate(-5.031 -32)", children: /* @__PURE__ */ r("path", { d: "M6.166,7.852h0l-.514-.775L1.56.909H3.321l3.3,4.977.514.775,4.293,6.47H9.669ZM11.43,0l-4.2,5.147L3.871,0H0L5.075,7.784,0,14H1.147L5.585,8.565,9.129,14H13L7.736,5.927,12.577,0Z", transform: "translate(14.031 40)", strokeWidth: "0" }) })
  }
));
export {
  c as default
};
